module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.14.0_gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__react-do_d5a8ff9abe6b960e07b4dd1b86f54fe1/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a1dd171e6c83e4f6f6a95027e612c68a"},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-fontawesome@1.3.1_@fortawesome+fontawesome-svg-core@6.7.2_gatsby@5.14.5_b_55482fb3afbf7339454a341cfc942494/node_modules/gatsby-plugin-fontawesome/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@1_2723fa06a6ad7d7db6a3151a512bed04/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
